import { render } from "./protocol_changes.vue?vue&type=template&id=23a4a292"
import script from "./protocol_changes.vue?vue&type=script&lang=js"
export * from "./protocol_changes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/inside/changes/protocol_changes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23a4a292"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23a4a292', __exports__)) {
    console.log('reload')
    api.reload('23a4a292', __exports__)
  }
  
  module.hot.accept("./protocol_changes.vue?vue&type=template&id=23a4a292", () => {
    console.log('re-render')
    api.rerender('23a4a292', render)
  })

}


export default __exports__